export class DownloadPukalAccount {
  WarrantAuthCode: string;
  Encryption: boolean;
}

export class JAN_Pukal {
  agentCode: string;
  accountOfficeCode: string;
  accountStatus: string;
  fileStatus: string;
  warrantPTJ: string;
  pukalNo: string;
  page: number = 1;
}

export class State_Pukal {
  agentCode: string;
  accountOfficeCode: string;
  accountStatus: string;
  fileStatus: string;
  warrantPTJ: string;
  pukalNo: string;
  page: number;
}

export class SearchPukal {
  agentCode: string;
  accountOfficeCode: string;
  accountStatus: string;
  fileStatus: string;
  warrantPTJ: string;
  pukalNo: string;
  page: number;
}

export class SearchSarawakPukal {
  agentCode: string;
  accountStatus: string;
  fileStatus: string;
  ptjCode: string;
  accNo: string;
  page: number;
}

export interface PukalPagedList {
  Airline_Agency_Code: string;
  Agency_Name: string;
  Acc_Off_Code: number;
  Acc_Off: string;
  Warrant_RCCC: string;
  Acc_No: string;
  Acc: string;
  Rcd_Sts: string;
  Active_Flag: string;
  Warrant_Auth_Code: string;
  Rcd_Sts_Code: number;
  Acc_Sts_Code: number;
  Auto_No: string;
  Warrant_Dept: string;
}

export interface AgentCode {
  Airline_Agency_Code: string;
  Agency_Name: string;
}

export interface AccountOffice {
  Acc_Off_Code: number;
  Acc_Off: string;
}

export interface AccountStatus {
  Acc_Sts_Code: number;
  Acc_Sts: string;
}

export interface RecordStatus {
  Rcd_Sts_Code: number;
  Rcd_Sts: string;
}

export interface InitJANPukalObject {
  pukalPagedList: PukalPagedList[];
  countPukalList: number;
  agentCodes: AgentCode[];
  accountOffices: AccountOffice[];
  accountStatus: AccountStatus[];
  recordStatus: RecordStatus[];
}

export interface InitStatePukalObject {
  pukalPagedList: PukalPagedList[];
  countPukalList: number;
  agentCodes: AgentCode[];
  accountOffices: AccountOffice[];
  accountStatus: AccountStatus[];
  recordStatus: RecordStatus[];
}

export interface JANPukalObject {
  pukalPagedList: PukalPagedList[];
  countPukalList: number;
}

export interface PukalObject {
  pukalPagedList: PukalPagedList[];
  countPukalList: number;
}
